import Lookup from 'src/componentes/select2';

const Operador = (props) => (
  <Lookup labelKey="simbolo" valueKey="id" url="/OperadorLookup" {...props} />
);

export default Operador;
